import { combineReducers } from "redux";
import commonReducer from "@redux/feature/Markets/Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketParams";
import highestPremiumDiscountReducer from "./highestPremiumDiscount";
export default combineReducers({
    reducersData: highestPremiumDiscountReducer,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
